// TODO: Talk to ryan to figure out how and when to handle the .14 date
import { buildBibleReading } from "./buildBibleReading";
document.addEventListener("DOMContentLoaded", buildBibleReading);
